export const OPEN_DETAILS_PANEL = "OPEN_DETAILS_PANEL";
export const CLOSE_DETAILS_PANEL = "CLOSE_DETAILS_PANEL";
export const SET_DETAILS_PANEL = "SET_DETAILS_PANEL";
export const SET_CURRENT_HASH = "SET_CURRENT_HASH";
